/* StrongHer theme — header, mobile menu, AJAX cart and product form.
   No build step and no dependencies: this file ships as-is. */
(function () {
  'use strict';

  var config = window.StrongHer || {};
  var routes = config.routes || {};
  var strings = config.strings || {};

  /* ---------------------------------------------------------------- utils */

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }
  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function track(event, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: event }, payload || {}));
    if (typeof window.gtag === 'function') window.gtag('event', event, payload || {});
  }
  window.StrongHerTrack = track;

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error(data.description || data.message || strings.error);
        return data;
      });
    });
  }

  /* --------------------------------------------------------------- header */

  var header = $('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 16);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  var menuToggle = $('[data-menu-toggle]');
  var mobileMenu = $('[data-mobile-menu]');

  function setMenu(open) {
    if (!menuToggle || !mobileMenu) return;
    mobileMenu.classList.toggle('is-open', open);
    mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
    menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('menu-open', open);
    $$('a', mobileMenu).forEach(function (link) {
      link.setAttribute('tabindex', open ? '0' : '-1');
    });
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', function () {
      setMenu(!mobileMenu.classList.contains('is-open'));
    });
  }

  /* ----------------------------------------------------------- hero video */

  /* The Next.js hero only played its video when motion was welcome; keep that. */
  var heroVideos = $$('[data-hero-video]');
  if (heroVideos.length) {
    var motionOk = !window.matchMedia || window.matchMedia('(prefers-reduced-motion: no-preference)').matches;
    heroVideos.forEach(function (video) {
      if (!motionOk) {
        video.remove();
        return;
      }
      video.setAttribute('autoplay', '');
      var attempt = video.play();
      if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
    });
  }

  /* ----------------------------------------------------------- cart drawer */

  function drawerOpen() {
    return document.body.classList.contains('drawer-open');
  }

  function openDrawer() {
    document.body.classList.add('drawer-open');
    var close = $('[data-cart-close]');
    if (close) close.focus();
    track('cart_view', {});
  }

  function closeDrawer() {
    document.body.classList.remove('drawer-open');
  }

  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var target = document.getElementById('shopify-section-' + id);
      if (!target) return;
      var parsed = new DOMParser().parseFromString(sections[id], 'text/html');
      var source = parsed.getElementById('shopify-section-' + id);
      target.innerHTML = source ? source.innerHTML : sections[id];
    });
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (node) {
      node.textContent = count;
      if (count > 0) {
        node.removeAttribute('hidden');
      } else {
        node.setAttribute('hidden', '');
      }
    });
  }

  function showCartError(message) {
    var node = $('[data-cart-error]');
    if (!node) return;
    node.textContent = message || strings.error;
    node.removeAttribute('hidden');
  }

  function swapDrawer(html) {
    var target = document.getElementById('shopify-section-cart-drawer');
    if (!target || !html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var source = parsed.getElementById('shopify-section-cart-drawer');
    target.innerHTML = source ? source.innerHTML : html;
  }

  /* Fallback used whenever a cart response comes back without rendered sections.
     One extra GET, but it always reflects the real cart. */
  function refreshDrawer() {
    return fetch(routes.root + '?section_id=cart-drawer', { headers: { Accept: 'text/html' } })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        swapDrawer(html);
        syncCount();
      })
      .catch(function () {
        /* leave the drawer as-is rather than blanking it */
      });
  }

  function applyCartResponse(data) {
    var rendered = data && data.sections && data.sections['cart-drawer'];
    if (rendered) {
      swapDrawer(rendered);
      syncCount();
      return Promise.resolve();
    }
    return refreshDrawer();
  }

  function syncCount() {
    var source = $('[data-cart-count-value]');
    if (source) updateCount(parseInt(source.getAttribute('data-cart-count-value'), 10) || 0);
  }

  function setBusy(busy) {
    var drawer = $('.cart-drawer');
    if (!drawer) return;
    if (busy) {
      drawer.setAttribute('aria-busy', 'true');
    } else {
      drawer.removeAttribute('aria-busy');
    }
  }

  function addToCart(variantId, quantity) {
    // Open first: the panel is on screen before the request lands, so the click
    // never feels dead. The count and lines fill in when the response arrives.
    openDrawer();
    setBusy(true);

    return postJSON(routes.cartAdd, {
      items: [{ id: variantId, quantity: quantity || 1 }],
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    })
      .then(applyCartResponse)
      .finally(function () {
        setBusy(false);
      });
  }

  function changeLine(line, quantity) {
    setBusy(true);
    return postJSON(routes.cartChange, {
      line: line,
      quantity: quantity,
      sections: 'cart-drawer',
      sections_url: window.location.pathname
    })
      .then(function (cart) {
        track('cart_update', { line: line, quantity: quantity });
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }
        return applyCartResponse(cart);
      })
      .catch(function (error) {
        showCartError(error.message);
      })
      .finally(function () {
        setBusy(false);
      });
  }

  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-cart-open]');
    if (open) {
      event.preventDefault();
      openDrawer();
      return;
    }

    var close = event.target.closest('[data-cart-close]');
    if (close) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var qtyButton = event.target.closest('[data-qty][data-line]');
    if (qtyButton) {
      event.preventDefault();
      changeLine(parseInt(qtyButton.getAttribute('data-line'), 10), parseInt(qtyButton.getAttribute('data-qty'), 10));
      return;
    }

    var addButton = event.target.closest('[data-add-to-cart]');
    if (addButton) {
      event.preventDefault();
      var form = addButton.closest('[data-product-form]');
      var variantId = form ? form.getAttribute('data-variant-id') : addButton.getAttribute('data-variant-id');
      if (!variantId) return;
      var label = addButton.textContent;
      addButton.disabled = true;
      addButton.textContent = strings.adding;
      track('add_to_cart', {
        variant_id: variantId,
        program: addButton.getAttribute('data-program') || '',
        placement: addButton.getAttribute('data-placement') || 'main'
      });
      addToCart(variantId, 1)
        .catch(function (error) {
          showCartError(error.message);
        })
        .finally(function () {
          addButton.disabled = false;
          addButton.textContent = label;
        });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (drawerOpen()) closeDrawer();
    if (mobileMenu && mobileMenu.classList.contains('is-open')) setMenu(false);
  });

  /* --------------------------------------------------------- product form */

  $$('[data-product-form]').forEach(function (form) {
    var priceNode = $('[data-variant-price]', form);
    var button = $('[data-add-to-cart]', form);

    $$('input[type="radio"]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        var option = input.closest('label');
        form.setAttribute('data-variant-id', input.value);
        $$('label', form).forEach(function (node) {
          node.classList.remove('selected');
        });
        if (option) option.classList.add('selected');

        var available = input.getAttribute('data-available') === 'true';
        var price = input.getAttribute('data-price') || '';
        if (priceNode) priceNode.textContent = price;
        if (button) {
          button.disabled = !available;
          button.textContent = available ? button.getAttribute('data-label') + ' — ' + price : strings.soldOut;
        }
      });
    });
  });

  /* ------------------------------------------------------ product tracking */

  var productMeta = $('[data-product-view]');
  if (productMeta) {
    track('program_view', {
      handle: productMeta.getAttribute('data-handle'),
      title: productMeta.getAttribute('data-title')
    });
  }

  /* --------------------------------------------------------- outbound CTAs */

  document.addEventListener('click', function (event) {
    var tracked = event.target.closest('[data-track]');
    if (!tracked) return;
    var payload = {};
    var raw = tracked.getAttribute('data-track-payload');
    if (raw) {
      try {
        payload = JSON.parse(raw);
      } catch (error) {
        payload = {};
      }
    }
    track(tracked.getAttribute('data-track'), payload);
  });
})();
